import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=12a9a5da&scoped=true&"
import script from "./restore.vue?vue&type=script&lang=js&"
export * from "./restore.vue?vue&type=script&lang=js&"
import style0 from "./restore.vue?vue&type=style&index=0&id=12a9a5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9a5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a9a5da')) {
      api.createRecord('12a9a5da', component.options)
    } else {
      api.reload('12a9a5da', component.options)
    }
    module.hot.accept("./restore.vue?vue&type=template&id=12a9a5da&scoped=true&", function () {
      api.rerender('12a9a5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/login/restore.vue"
export default component.exports